import { render, staticRenderFns } from "./ViewProxyswipes.vue?vue&type=template&id=54c35c44"
import script from "./ViewProxyswipes.vue?vue&type=script&lang=js"
export * from "./ViewProxyswipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports